export default "__VITE_ASSET__8f6c6056__"